import { ActivityCard } from '../Cards/ActivityCard';
import { MARGIN_HORIZONTAL_DASHBOARD_ITEM } from '../../config/designSystem/Layout';
import { PathCard } from '../Cards/PathCard';
import { View } from 'react-native';
import { concatPath } from '../../utils/links/concatPath';
import { contentTypeForActivityItem } from '../../types/types';
import { pathKey } from '../../constants/routeKeys';
import { router } from 'expo-router';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';


export type HorizontalItemContentType = contentTypeForActivityItem | 'PATH';

type HorizontalItemProp = {
  contentType: HorizontalItemContentType;
  id: string;
  displayButtonBelow: boolean;
  showActivityType?: boolean | null;
  small?: boolean;
};

export const HorizontalItem = ({id, contentType, displayButtonBelow,showActivityType, small}: HorizontalItemProp) => {
  const isPath: boolean = contentType === 'PATH';
  const { width } = useAvailableDimensions();


  let onPressPath = () => {};
  if(isPath) {
    onPressPath = () => {
      const params = displayButtonBelow ? {id, displayButtonBelow: encodeURIComponent(displayButtonBelow)} : {id};
      router.navigate({
        pathname: concatPath([ pathKey], 0) as string,
        params});

    };
  }
  return (
    <View style={{ marginHorizontal: MARGIN_HORIZONTAL_DASHBOARD_ITEM(width)}}>
      {isPath ? (
        <PathCard
          id={id}
          onPress={onPressPath}
          small={small}
        />
      ) : (
        <ActivityCard
          id={id}
          contentType={contentType as contentTypeForActivityItem}
          showActivityType={showActivityType}
        />
      )}
    </View>
  );
};

